import type { ValueOf } from '@direct-frontend/stdlib';
import type { VectorCustomization, YMapLocationRequest } from '@yandex/ymaps3-types';

/** Регулярка для координат */
export const coordsRegex = /^(\d+[.,]\d+)[.,]?\s+(\d+[.,]\d+)$/;

/** Id для canvas для отрисовки полигонов */
export const canvasId = 'polygon-canvas';

/** Параметры анимации карты */
export const mapAnimationParams: Pick<YMapLocationRequest, 'duration' | 'easing'> = {
    easing: 'ease-in-out',
    duration: 1000,
};

/** Параметры анимации карты при зуме */
export const zoomAnimationParams: Pick<YMapLocationRequest, 'duration' | 'easing'> = {
    easing: 'ease-in-out',
    duration: 200,
};

/** Перекрашивание POI в монохром */
export const mapCustomization: VectorCustomization = [
    {
        tags: {
            any: 'poi',
        },
        types: 'point',
        stylers: [
            {
                saturation: -1,
            },
        ],
    },
];

/** Процент дельты для расширения границ карты */
export const boundsDeltaPercent = 0.4;

/**
 * Опциональные дополннения для подключения
 * @kind enum
 */
export const YMapAddon = {
    /** Модуль @yandex/ymaps3-controls-extra */
    controlsExtra: 'controls-extra',
    /** Модуль @yandex/ymaps3-ruler */
    ruler: 'ruler',
    /** Пакет @yandex/ymaps3-hint */
    hint: 'hint',
    /** Пакет @yandex/ymaps3-default-ui-theme */
    defaultUITheme: 'defaultUITheme',
    /** Пакет @yandex/ymaps3-clusterer */
    clusterer: 'clusterer',
} as const;

/** Допустимое множество опционально подключаемых дополнений */
export type YMapAddon = ValueOf<typeof YMapAddon>;

/** Доступные языки для карт */
export const MapLanguage = {
    ru_RU: 'ru_RU',
    ru_UA: 'ru_UA',
    uk_UA: 'uk_UA',
    en_RU: 'en_RU',
    tr_TR: 'tr_TR',
    en_US: 'en_US',
    he_IL: 'he_IL',
    en_IL: 'en_IL',
} as const;

/** Допустимое множество языков */
export type MapLanguage = ValueOf<typeof MapLanguage>;

/**
 * Статус инициализации карт
 * @kind enum
 */
export const MapInitStatus = {
    /** Не проинициализировано */
    NOT_INITIALIZED: 'notInitialized',
    /** Загрузка */
    PENDING: 'pending',
    /** Готово к использованию */
    READY: 'ready',
    /** Ошибка загрузки */
    ERROR: 'error',
} as const;
export type MapInitStatus = ValueOf<typeof MapInitStatus>;

/**
 * Типы маркеров
 * @kind enum
 */
export const MarkerType = {
    available: 'available',
    focused: 'focused',
    selected: 'selected',
    unavailable: 'unavailable',
} as const;
export type MarkerType = ValueOf<typeof MarkerType>;

/**
 * Размеры маркеров
 * @kind enum
 */
export const MarkerSize = {
    xxs: '14',
    xs: '16',
    small: '24',
    big: '32',
} as const;
export type MarkerSize = ValueOf<typeof MarkerSize>;

/**
 * Доступные способы выделения маркеров
 * @kind enum
 */
export const MarkersSelectionType = {
    /** Выделение полигонами */
    polygons: 'polygons',
    /** Выделение при помощи лассо */
    lasso: 'lasso',
    /** Выделение при помощи окружностей */
    circles: 'circles',
} as const;
export type MarkersSelectionType = ValueOf<typeof MarkersSelectionType>;
